import React from 'react';

export interface IExternalLinkProps extends React.HTMLProps<HTMLAnchorElement> {}

export function ExternalLink(props: IExternalLinkProps) {
  return (
    <a {...props} target="_blank" rel="noopener noreferrer">
      {props.children}
    </a>
  );
}
